"use strict";
"use client";

var _defineProperty = require("/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty.js").default;

var _objectSpread = require("/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread2.js").default;

var _objectWithoutProperties = require("/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectWithoutProperties.js").default;

var _slicedToArray = require("/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray.js").default;

var _createForOfIteratorHelper = require("/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper.js").default;

var _excluded = ["__scopeCollapsible", "open", "defaultOpen", "disabled", "onOpenChange"],
    _excluded2 = ["__scopeCollapsible"],
    _excluded3 = ["forceMount"],
    _excluded4 = ["__scopeCollapsible", "present", "children"];
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;

var __export = function __export(target, all) {
  for (var name in all) __defProp(target, name, {
    get: all[name],
    enumerable: true
  });
};

var __copyProps = function __copyProps(to, from, except, desc) {
  if (from && typeof from === "object" || typeof from === "function") {
    var _iterator = _createForOfIteratorHelper(__getOwnPropNames(from)),
        _step;

    try {
      var _loop = function _loop() {
        var key = _step.value;
        if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
          get: function get() {
            return from[key];
          },
          enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
        });
      };

      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return to;
};

var __toESM = function __toESM(mod, isNodeMode, target) {
  return target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps( // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", {
    value: mod,
    enumerable: true
  }) : target, mod);
};

var __toCommonJS = function __toCommonJS(mod) {
  return __copyProps(__defProp({}, "__esModule", {
    value: true
  }), mod);
}; // src/index.ts


var index_exports = {};

__export(index_exports, {
  Collapsible: function Collapsible() {
    return _Collapsible;
  },
  CollapsibleContent: function CollapsibleContent() {
    return _CollapsibleContent;
  },
  CollapsibleTrigger: function CollapsibleTrigger() {
    return _CollapsibleTrigger;
  },
  Content: function Content() {
    return _Content;
  },
  Root: function Root() {
    return _Root;
  },
  Trigger: function Trigger() {
    return _Trigger;
  },
  createCollapsibleScope: function createCollapsibleScope() {
    return _createCollapsibleScope;
  }
});

module.exports = __toCommonJS(index_exports); // src/collapsible.tsx

var React = __toESM(require("react"));

var import_primitive = require("@radix-ui/primitive");

var import_react_context = require("@radix-ui/react-context");

var import_react_use_controllable_state = require("@radix-ui/react-use-controllable-state");

var import_react_use_layout_effect = require("@radix-ui/react-use-layout-effect");

var import_react_compose_refs = require("@radix-ui/react-compose-refs");

var import_react_primitive = require("@radix-ui/react-primitive");

var import_react_presence = require("@radix-ui/react-presence");

var import_react_id = require("@radix-ui/react-id");

var import_jsx_runtime = require("react/jsx-runtime");

var COLLAPSIBLE_NAME = "Collapsible";

var _ref = (0, import_react_context.createContextScope)(COLLAPSIBLE_NAME),
    _ref2 = _slicedToArray(_ref, 2),
    createCollapsibleContext = _ref2[0],
    _createCollapsibleScope = _ref2[1];

var _createCollapsibleCon = createCollapsibleContext(COLLAPSIBLE_NAME),
    _createCollapsibleCon2 = _slicedToArray(_createCollapsibleCon, 2),
    CollapsibleProvider = _createCollapsibleCon2[0],
    useCollapsibleContext = _createCollapsibleCon2[1];

var _Collapsible = React.forwardRef(function (props, forwardedRef) {
  var __scopeCollapsible = props.__scopeCollapsible,
      openProp = props.open,
      defaultOpen = props.defaultOpen,
      disabled = props.disabled,
      onOpenChange = props.onOpenChange,
      collapsibleProps = _objectWithoutProperties(props, _excluded);

  var _ref3 = (0, import_react_use_controllable_state.useControllableState)({
    prop: openProp,
    defaultProp: defaultOpen !== null && defaultOpen !== void 0 ? defaultOpen : false,
    onChange: onOpenChange,
    caller: COLLAPSIBLE_NAME
  }),
      _ref4 = _slicedToArray(_ref3, 2),
      open = _ref4[0],
      setOpen = _ref4[1];

  return /* @__PURE__ */(0, import_jsx_runtime.jsx)(CollapsibleProvider, {
    scope: __scopeCollapsible,
    disabled: disabled,
    contentId: (0, import_react_id.useId)(),
    open: open,
    onOpenToggle: React.useCallback(function () {
      return setOpen(function (prevOpen) {
        return !prevOpen;
      });
    }, [setOpen]),
    children: /* @__PURE__ */(0, import_jsx_runtime.jsx)(import_react_primitive.Primitive.div, _objectSpread(_objectSpread({
      "data-state": getState(open),
      "data-disabled": disabled ? "" : void 0
    }, collapsibleProps), {}, {
      ref: forwardedRef
    }))
  });
});

_Collapsible.displayName = COLLAPSIBLE_NAME;
var TRIGGER_NAME = "CollapsibleTrigger";

var _CollapsibleTrigger = React.forwardRef(function (props, forwardedRef) {
  var __scopeCollapsible = props.__scopeCollapsible,
      triggerProps = _objectWithoutProperties(props, _excluded2);

  var context = useCollapsibleContext(TRIGGER_NAME, __scopeCollapsible);
  return /* @__PURE__ */(0, import_jsx_runtime.jsx)(import_react_primitive.Primitive.button, _objectSpread(_objectSpread({
    type: "button",
    "aria-controls": context.contentId,
    "aria-expanded": context.open || false,
    "data-state": getState(context.open),
    "data-disabled": context.disabled ? "" : void 0,
    disabled: context.disabled
  }, triggerProps), {}, {
    ref: forwardedRef,
    onClick: (0, import_primitive.composeEventHandlers)(props.onClick, context.onOpenToggle)
  }));
});

_CollapsibleTrigger.displayName = TRIGGER_NAME;
var CONTENT_NAME = "CollapsibleContent";

var _CollapsibleContent = React.forwardRef(function (props, forwardedRef) {
  var forceMount = props.forceMount,
      contentProps = _objectWithoutProperties(props, _excluded3);

  var context = useCollapsibleContext(CONTENT_NAME, props.__scopeCollapsible);
  return /* @__PURE__ */(0, import_jsx_runtime.jsx)(import_react_presence.Presence, {
    present: forceMount || context.open,
    children: function children(_ref5) {
      var present = _ref5.present;
      return /* @__PURE__ */(0, import_jsx_runtime.jsx)(CollapsibleContentImpl, _objectSpread(_objectSpread({}, contentProps), {}, {
        ref: forwardedRef,
        present: present
      }));
    }
  });
});

_CollapsibleContent.displayName = CONTENT_NAME;
var CollapsibleContentImpl = React.forwardRef(function (props, forwardedRef) {
  var __scopeCollapsible = props.__scopeCollapsible,
      present = props.present,
      children = props.children,
      contentProps = _objectWithoutProperties(props, _excluded4);

  var context = useCollapsibleContext(CONTENT_NAME, __scopeCollapsible);

  var _React$useState = React.useState(present),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      isPresent = _React$useState2[0],
      setIsPresent = _React$useState2[1];

  var ref = React.useRef(null);
  var composedRefs = (0, import_react_compose_refs.useComposedRefs)(forwardedRef, ref);
  var heightRef = React.useRef(0);
  var height = heightRef.current;
  var widthRef = React.useRef(0);
  var width = widthRef.current;
  var isOpen = context.open || isPresent;
  var isMountAnimationPreventedRef = React.useRef(isOpen);
  var originalStylesRef = React.useRef(void 0);
  React.useEffect(function () {
    var rAF = requestAnimationFrame(function () {
      return isMountAnimationPreventedRef.current = false;
    });
    return function () {
      return cancelAnimationFrame(rAF);
    };
  }, []);
  (0, import_react_use_layout_effect.useLayoutEffect)(function () {
    var node = ref.current;

    if (node) {
      originalStylesRef.current = originalStylesRef.current || {
        transitionDuration: node.style.transitionDuration,
        animationName: node.style.animationName
      };
      node.style.transitionDuration = "0s";
      node.style.animationName = "none";
      var rect = node.getBoundingClientRect();
      heightRef.current = rect.height;
      widthRef.current = rect.width;

      if (!isMountAnimationPreventedRef.current) {
        node.style.transitionDuration = originalStylesRef.current.transitionDuration;
        node.style.animationName = originalStylesRef.current.animationName;
      }

      setIsPresent(present);
    }
  }, [context.open, present]);
  return /* @__PURE__ */(0, import_jsx_runtime.jsx)(import_react_primitive.Primitive.div, _objectSpread(_objectSpread({
    "data-state": getState(context.open),
    "data-disabled": context.disabled ? "" : void 0,
    id: context.contentId,
    hidden: !isOpen
  }, contentProps), {}, {
    ref: composedRefs,
    style: _objectSpread(_defineProperty(_defineProperty({}, "--radix-collapsible-content-height", height ? "".concat(height, "px") : void 0), "--radix-collapsible-content-width", width ? "".concat(width, "px") : void 0), props.style),
    children: isOpen && children
  }));
});

function getState(open) {
  return open ? "open" : "closed";
}

var _Root = _Collapsible;
var _Trigger = _CollapsibleTrigger;
var _Content = _CollapsibleContent;